import { createFileRoute, redirect } from "@tanstack/react-router";
import PortalScopeEmptyState from "src/components/app/PortalScopeEmptyState/PortalScopeEmptyState";
import { organisationPath, projectPath } from "src/lib/PortalPaths";

// The bare portal opens the visitor's last project (the cookies' default), or their organisation
// when it has none they can open.
export const Route = createFileRoute("/_authed/portal/")({
  loader: async ({ parentMatchPromise }) => {
    const layout = (await parentMatchPromise).loaderData;
    const org = layout?.organisations.find((candidate) => candidate.id === layout.selectedOrgId);
    if (!org) return;
    const project = layout?.projects.items.find((item) => item.id === layout.selectedProjectId);
    throw redirect({
      href: project ? projectPath(project.id) : organisationPath(org.id),
      replace: true,
    });
  },
  component: () => <PortalScopeEmptyState missing="organisation" />,
});
